
import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiLinkedin, FiMail} = FiIcons;

const AboutTeam = () => {
  const teamMembers = [
    {
      name: 'Nicholas Fendel',
      role: 'Founder & Managing Director',
      bio: 'Former engineering leader turned recruitment specialist. 8+ years in robotics and AI, with deep understanding of what makes exceptional technical teams.',
      image: '/placeholder-founder.jpg',
      linkedin: 'https://www.linkedin.com/in/nicholasfendel/',
      email: 'nicholas@trbe.ai'
    },
    {
      name: 'Julia Fischer',
      role: 'Tech Recruiter',
      bio: 'Psychology graduate who transitioned into tech recruitment. Combines deep understanding of human behavior with technical expertise to find perfect candidate-culture fits.',
      image: '/placeholder-julia.jpg',
      linkedin: 'https://www.linkedin.com/in/julia-fischer-ba3636227/',
      email: 'julia@trbe.ai'
    },
    {
      name: 'Eric Reed',
      role: 'Business Consultant',
      bio: 'Organizational development specialist focusing on Agile transformations and scaling tech teams. Helps companies build robust organizational structures and implement effective development processes.',
      image: '/placeholder-eric.jpg',
      linkedin: 'https://www.linkedin.com/in/eric-reed-cv/',
      email: 'eric@trbe.ai'
    }
  ];

  return (
    <section className="py-20 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl font-bold text-brand-purple mb-4">
            Meet Our Team
          </h2>
          <p className="text-xl text-brand-blue max-w-3xl mx-auto">
            Led by industry professionals who understand both the technical and human sides of building great teams.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-xl p-8 shadow-lg text-center max-w-sm mx-auto"
            >
              <div className="w-32 h-32 bg-gradient-to-br from-brand-blue to-brand-lightblue rounded-full mx-auto mb-6 flex items-center justify-center">
                <span className="text-white text-2xl font-bold">
                  {member.name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
              <h3 className="text-xl font-semibold text-brand-purple mb-2">
                {member.name}
              </h3>
              <p className="text-brand-orange font-medium mb-4">
                {member.role}
              </p>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {member.bio}
              </p>
              <div className="flex justify-center space-x-4">
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-brand-blue rounded-full flex items-center justify-center text-white hover:bg-brand-purple transition-colors"
                >
                  <SafeIcon icon={FiLinkedin} className="h-5 w-5" />
                </a>
                <a
                  href={`mailto:${member.email}`}
                  className="w-10 h-10 bg-brand-orange rounded-full flex items-center justify-center text-white hover:bg-secondary-500 transition-colors"
                >
                  <SafeIcon icon={FiMail} className="h-5 w-5" />
                </a>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Company Story */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-16 bg-white rounded-xl p-8 shadow-lg"
        >
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-2xl font-bold text-brand-purple mb-6">
              Our Story
            </h3>
            <p className="text-lg text-brand-blue leading-relaxed mb-6">
              Founded in Berlin, Trbe was born from the frustration of seeing brilliant deep tech companies struggle to find the right engineering talent. Having worked in robotics and AI ourselves, we understand the unique challenges of hiring in these specialized fields.
            </p>
            <p className="text-lg text-brand-blue leading-relaxed">
              We bridge the gap between exceptional technical talent and innovative companies, focusing not just on skills but on building teams that truly work together. Our approach combines industry expertise with a human-centered philosophy – because the future is built by people, not just technology.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutTeam;
